import React from 'react';
import Select, { MenuPlacement } from 'react-select';
import { FoundationsOptionType } from '../Types/FoundationsTypes';
 
interface reactSelectDropdownProps {
    options: FoundationsOptionType[]; // Dropdown options format
    value?: any[];
    onChange: (result: FoundationsOptionType[] | FoundationsOptionType ) => void;
    placeholder?: string;
    multiple?: boolean;
    id: string; // dropdown Id
    styleProps?: any,
    isClearable: boolean,
    menuPlacement: MenuPlacement,
}

//FP-11666- Some colors got from foundations color code, and other colors identified from ui
export const DarkModeColors = {
    DarkGrey: '#495057', // dark grey background color as per previous version.
    DarkerGrey: "#333",
    textColorWhite: "#fff",
    grey: 'grey',
    BlueGreyDark: '#2f3337',
    lightGrey: "#bbbbbb",
    lightGrey1: '#616161',
    DarkBlue: "#305a9d",
    HoverDarkGrey: "#4d4d4d",
    ListItemSelectedGrey: '#747474',
    AdminTasksGrey: "#495057"
}

export const LightModeColors = {
grey: 'grey',
    textColorLightBlack: "#ccc",
    textColorBlack: "#000",
    textColorWhite: "#fff",
    lightGrey: "#bbbbbb",
    DarkGrey: "#495057",
    LightBlue: "#62a0de",
    DarkBlue: '#0e4a67',
    Grey2: '#888888',
    LightBlue1: '#6394f6'
}
export const ReactSelect_DarkMode = { //these changes are consistent across Foundations.
    control: (provided: any, state: any) => ({
        ...provided,
        minHeight: '32px',
        height: '32px',
        paddingTop: 0,
        paddingBottom: 3,
        backgroundColor: DarkModeColors.DarkGrey, //background color of a container
        borderColor: DarkModeColors.grey, //border color of a container
        color: DarkModeColors.textColorWhite, //
        minWidth: 140,
        borderWidth: '1px',
        borderStyle: 'solid',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0, //here need to revert to 2 if its not suitable
        marginBottom: 2,
        backgroundColor: DarkModeColors.DarkGrey,
        minHeight: '27px',
        height: '27px',
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        height: '30px',
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    clearIndicator: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 3,
    }),
    menu: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: DarkModeColors.DarkerGrey, //dropdown open menu background color
        color: DarkModeColors.textColorWhite,
    }),
    input: (base: any) => ({
        ...base,
        color: DarkModeColors.textColorWhite, //white
    }),
    placeholder: (base: any) => ({
        ...base,
        color: DarkModeColors.textColorWhite,
    }),
    singleValue: (base: any) => ({
        ...base,
        color: DarkModeColors.textColorWhite,
        borderColor: DarkModeColors.grey, //border color of a container
    }),
    option: (provided: any, state: any) => {
        let bgColor = DarkModeColors.BlueGreyDark; // default
        let textColor = DarkModeColors.textColorWhite;  // default

        if (state.isDisabled) {
            textColor = DarkModeColors.lightGrey; // lighter gray for disabled
            bgColor = DarkModeColors.BlueGreyDark;   // no change on hover or select
        } else if (state.isFocused) {
            // bgColor = DarkModeColors.lightGrey1;   // hover background
            bgColor = DarkModeColors.DarkBlue;   // hover background
        }

        return {
            ...provided,
            backgroundColor: state.isSelected ? DarkModeColors.ListItemSelectedGrey : bgColor,
            color: textColor,
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            // remove default active style (when clicking)
            ':active': {
                backgroundColor: bgColor,
            },
        };
    },
    //for multiple selected container customisations
    multiValue: (provided: any) => ({ //container of multiple selected items
        ...provided,
        // backgroundColor: DarkModeColors.lightGrey1, //here3
        backgroundColor: 'transparent', //here3
        color: DarkModeColors.textColorWhite,
        // borderRadius: '2px',
        border: `1px solid ${DarkModeColors.HoverDarkGrey}`, //border color of a 
        borderRadius: '2px',
        paddingBottom: 0,
        fontSize: '11px', //here font size originally 10px
        margin: '2px 3px 2px 3px',
    }),
    multiValueLabel: (provided: any) => ({
        ...provided,
        color: DarkModeColors.textColorWhite,
        fontSize: '11px', //here font size originally 10px
        paddingBottom: 0,
    }),

    multiValueRemove: (provided: any) => ({
        ...provided,
        color: DarkModeColors.textColorWhite,
        ':hover': {
            backgroundColor: DarkModeColors.HoverDarkGrey,
            color: DarkModeColors.textColorWhite,
        },
    }),
    noOptionsMessage: (provided: any) => ({ //FP-12439
    ...provided,
    color: DarkModeColors.textColorWhite,
  }),
};

export const ReactSelect_LightMode = { //these changes are consistent across Foundations.
    noOptionsMessage: (provided: any) => ({ //FP-12439
    ...provided,
    color: LightModeColors.textColorBlack,
  }),
    control: (provided: any) => ({
        ...provided,
        minHeight: '32px',
        height: '32px',
        paddingTop: 0,
        paddingBottom: 3,
        // backgroundColor: '#393939', //background color of a container
        borderColor: 'grey', //border color of a container
        color: '#ccc', //
        minWidth: 140,
        borderWidth: '1px',
        borderStyle: 'solid',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 2,
        height: '27px',
        minHeight: '27px',
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        height: '30px',
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    clearIndicator: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 3,
    }),
    menu: (provided: any) => ({
        ...provided,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    input: (base: any) => ({
        ...base,
        color: LightModeColors.textColorBlack, // this sets the color of the text typed in the search box
        fontSize: '12px',
    }),
    placeholder: (base: any) => ({
        ...base,
        color: LightModeColors.Grey2,
    }),
    singleValue: (base: any) => ({
        ...base,
        color: LightModeColors.textColorBlack,
        borderColor: LightModeColors.grey, //border color of a container
    }),
    option: (provided: any, state: any) => {
        let bgColor = LightModeColors.textColorWhite; // default
        let textColor = LightModeColors.textColorBlack;  // default

        if (state.isDisabled) {
            textColor = LightModeColors.DarkGrey; // lighter gray for disabled
            bgColor = LightModeColors.lightGrey;   // no change on hover or select
        } else if (state.isFocused) {
            bgColor = LightModeColors.LightBlue1;   // hover blue shade background
        }

        return {
            ...provided,
            // backgroundColor: state.isSelected ? '#305a9d' : bgColor, //blue
            backgroundColor: state.isSelected ? LightModeColors.lightGrey : bgColor, //grey
            color: state.isSelected ? LightModeColors.textColorBlack : textColor,
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            // remove default active style (when clicking)
            ':active': {
                backgroundColor: bgColor,
            },
        };
    },
    //for multiple select type customisations
    multiValue: (provided: any) => ({
        ...provided,
        // backgroundColor: LightModeColors.lightGrey, //here
        backgroundColor: '#e4e4e4',
        color: LightModeColors.textColorBlack,
        borderRadius: '2px',
        paddingBottom: 0,
        margin: '2px 3px 2px 3px',
    }),

    multiValueLabel: (provided: any) => ({
        ...provided,
        color: LightModeColors.textColorBlack,
        paddingBottom: 0,
        // marginBottom: 3,
        fontSize: '11px',
    }),

    multiValueRemove: (provided: any) => ({
        ...provided,
        color: LightModeColors.textColorBlack,
        paddingBottom: 2,
        ':hover': {
            // backgroundColor: '#ff4d4d', //red hover
            backgroundColor: LightModeColors.textColorLightBlack, //here blue hover
            color: LightModeColors.textColorWhite,
        },
    }),
};

// export const ReactSelect_SingleSelect = {
    //changes are in progress...
// }

const ReactSelectDropdown: React.FC<reactSelectDropdownProps> = ({ options, value, onChange, placeholder = 'Select an option', multiple = false, id, styleProps, isClearable = false, menuPlacement = "auto", value: any }) => {

    const handleChange = (selectedOption: any) => {
        onChange(selectedOption);
    };

    return (
        <Select
            menuPortalTarget={document.body}
            id={id}
            styles={{...styleProps, menuPortal: base => ({ ...base, zIndex: 9999 })}}
            options={options}
            menuPlacement={'auto'}
            isSearchable
            isMulti={multiple}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            isClearable={isClearable}
            className="basic-multi-select"
            classNamePrefix="select"
            isOptionDisabled={(option) => option.disabled} //control for which options are disabled
        />
    );
};
 
export default ReactSelectDropdown;